import React from 'react';
import ReactDOM from 'react-dom';
import EnergyDistributionModule from '../../Views/shared/react/EnergyDistribution/EnergyDistributionModule';

export function feature_js_energy_distribution_chart(scope, url) {

    ReactDOM.render(<EnergyDistributionModule url={url} />, scope[0]);
}